import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { IParidad, IParidadRequest, IParidadResponse } from './interfaces/paridad.interface';
import { ParidadService } from './services/paridad.service';
import Swal from 'sweetalert2';
import { ParidadFormComponent } from './paridad-form.component';

@Component({
  selector: 'app-paridades',
  templateUrl: './paridades.component.html',
  providers: [MessageService]
})
export class ParidadesComponent implements OnInit {
  @ViewChild('dt') dt!: Table;
  @ViewChild(ParidadFormComponent) paridadFormComponent!: ParidadFormComponent;

  displayDialog: boolean = false;
  selectedParidad: IParidad | null = null;
  dataSource: IParidad[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'fecha', header: 'Fecha', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'paridadDolar', header: 'Paridad Dólar', sortable: true },
    { field: 'paridadUdis', header: 'Paridad UDIS', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private paridadService: ParidadService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const request: IParidadRequest = {
      que: 4,
      tope: "999",
      cmd: "",
      fecha: "",
      descripcion: "",
      paridaddolar: 0,
      paridadudis: 0,
      par2ODBC: 0
    };

    this.paridadService.getParidades(request).subscribe({
      next: (response: IParidadResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar las paridades'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar las paridades'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openNew(): void {
    this.selectedParidad = null;
    this.displayDialog = true;
  }

  openUpdate(row: IParidad): void {
    this.selectedParidad = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: IParidad): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar esta paridad?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.paridadService.deleteParidad(row.par2ODBC).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Paridad eliminada correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: response.data?.error || 'Error al eliminar la paridad'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar la paridad'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedParidad = null;
    this.displayDialog = false;
    if (this.paridadFormComponent) {
      this.paridadFormComponent.clearForm();
    }
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }
} 